import {HONEY_POT_EMAIL, HONEY_POT_NAME} from './constants'
import { dispatchSelectChangeEvent } from './util/selectChangeEvent'

/**
 * @param {HTMLOptionElement} selectedOption
 * @return {string | undefined}
 */
function updateValue(selectedOption) {
    // return early if no option is selected, this is the case for the filling amount / packaging popup
    if (!selectedOption) {
        return;
    }
    const dropdown = selectedOption.closest('.select');
    const currentValueInput = dropdown.querySelector('.select__current-value');
    const html = selectedOption.innerHTML;
    const helperDiv = document.createElement("div");
    helperDiv.innerHTML = html;
    const newValue = currentValueInput.dataset.maxLength ? helperDiv.innerText.slice(0, Number(currentValueInput.dataset.maxLength)) : helperDiv.innerText;

    const newDataValue = selectedOption.dataset.value;
    if (newDataValue) {
        currentValueInput.value = newValue;
        currentValueInput.dataset.value = newDataValue;
    } else {
        currentValueInput.value = newValue;
    }

    dropdown.querySelectorAll('.option').forEach(function(option) {
        if(option.innerText === newValue) {
            option.classList.add('selected');
        } else if (!option.classList.contains('indent')) {
            option.classList.remove('selected');
        }
    });

    return currentValueInput.value;
}

function InitSelectMenu() {
    const selectLabels = document.querySelectorAll('.select__label');
    selectLabels.forEach((selectLabelItem) => {
        selectLabelItem.addEventListener('click', () => {
            selectLabelItem.closest('.select').classList.toggle('active');
        });
    });

    const options = document.querySelectorAll('.option');
    options.forEach((optionItem) => {
        optionItem.addEventListener('click', (event) => {
            const selectedValue = updateValue(optionItem);
            dispatchSelectChangeEvent(selectedValue, event, optionItem);
            optionItem.closest('.select').classList.remove('active');
        });
    });

    const selects = document.querySelectorAll('.select');
    selects.forEach((selectItem) => {
        const selectedOption = selectItem.querySelector('.option.selected');

        if (!!selectedOption) {
            updateValue(selectedOption);
        } else {
            updateValue(selectItem.querySelector('.option:first-child'));
        }
    });
}

/**
 * Closes the job application dialog and restores the initial state.
 * @param {HTMLElement} form
 * @param {HTMLElement} submitConfirmation
 * @param {HTMLElement} submitError
 */
function closeJobApplicationDialog(form, submitConfirmation, submitError) {
    const dialog = document.querySelector('#jobApplicationDialog');
    dialog.close();
    form.classList.remove('hidden');
    submitConfirmation.classList.add('hidden');
    submitError.classList.add('hidden');
}

function InitSubmitListener(form) {
    if (!!form) {
        form.addEventListener("submit", async function (e) {
            e.preventDefault();
            const formData = new FormData(form);

            const salutationValue = form.querySelector('.select__current-value')
            if (salutationValue) {
                formData.set('salutation', salutationValue.dataset.value.replaceAll('"', ''))
            }

            // exit early if honeypot fields are filled
            if (formData.get(HONEY_POT_NAME) || formData.get(HONEY_POT_EMAIL)) {
                return;
            }

            const url = form.getAttribute('action')

            const request = await fetch(url, {
                method: 'POST',
                body: formData,
            })

            const submitConfirmation = document.querySelector('[data-form="submit-confirmation"]');
            const submitError = document.querySelector('[data-form="submit-error"]');

            // check if status code is 2XX - success
            if (request.ok) {
                form.classList.add('hidden');
                submitConfirmation.classList.remove('hidden');
                // if inquiry form is sent, clear inquiry list
                if(form.id === 'inquiry-form') {
                    localStorage.removeItem('shopping-cart-storage');
                    document.querySelector('[data-shopping-cart]').setAttribute('data-shopping-cart-items', 0);
                }

                // if job application form is sent, close dialog
                if (form.id === 'job-application-form') {
                    setTimeout(() => {
                        closeJobApplicationDialog(form, submitConfirmation, submitError);
                    }, 7000)

                    const jobApplyButton = document.querySelector('[data-job-apply-button]');
                    const alreadyAppliedButton = document.querySelector('[data-job-already-applied-button]');

                    jobApplyButton.classList.add('hidden');
                    alreadyAppliedButton.classList.remove('hidden');
                }
            } else {
                form.classList.add('hidden')
                submitError.classList.remove('hidden')

                setTimeout(() => {
                    closeJobApplicationDialog(form, submitConfirmation, submitError);
                }, 7000);
            }
        });
    }
}

export default function InitForms() {
    InitSelectMenu();
    InitSubmitListener(document.getElementById('contact-form'));
    InitSubmitListener(document.getElementById('inquiry-form'));
    InitSubmitListener(document.getElementById('job-application-form'));
}
